import React from "react";
import classNames from "classnames";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Amount } from "@design-system/Amount/Amount";
import styles from "./TransactionAmount.module.scss";

interface Props {
    transaction: Pick<TransactionListItem, "amount" | "originalAmount">;
    addSign?: boolean;
    color?: boolean;
    className?: string;
    useOriginalAmount?: boolean;
}

export const TransactionAmount: React.FC<Props> = ({
    transaction,
    addSign = false,
    color = false,
    className,
    useOriginalAmount = false,
}) => {
    const amount = useOriginalAmount
        ? transaction.originalAmount
        : transaction.amount;

    return (
        <div
            className={classNames(
                styles.transactionAmount,
                {
                    [styles.color]: color,
                    [styles.credit]: amount > 0,
                    [styles.debit]: amount < 0,
                },
                className,
            )}
            data-testid="transaction-amount"
        >
            <Amount
                amount={amount}
                separateCurrencySign
                showNegative={addSign}
            />
        </div>
    );
};
